import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import React from "react";
import { useDispatch } from "react-redux";

import { validateEmail } from "../../helpers/validations";
import useInput from "../../hooks/use-input";
import { addCustomer } from "../../store/customers-actions";

const EditCustomerDialog = (props) => {
  const {
    value: email,
    isValid: emailIsValid,
    hasError: emailInputHasError,
    inputChangeHandler: emailInputChangeHandler,
    inputBlurHandler: emialInputBlurHandler,
    reset: emailInputReset,
    touch: emailInputTouched,
  } = useInput((x) => validateEmail(x));
  const {
    value: name,
    isValid: nameIsValid,
    hasError: nameInputHasError,
    inputChangeHandler: nameInputChangeHandler,
    inputBlurHandler: nameInputBlurHandler,
    reset: nameInputReset,
    touch: nameInputTouched,
  } = useInput((x) => x.trim() !== "");
  const {
    value: company,
    isValid: companyIsValid,
    hasError: companyInputHasError,
    inputChangeHandler: companyInputChangeHandler,
    inputBlurHandler: companyInputBlurHandler,
    reset: companyInputReset,
    touch: companyInputTouched,
  } = useInput((x) => x.trim() !== "");

  const dispatch = useDispatch();

  const formIsInvalid = !(emailIsValid && nameIsValid && companyIsValid);

  const closeHandler = () => {
    emailInputReset();
    nameInputReset();
    companyInputReset();

    props.onClose();
  };

  const saveButtonClickHandler = async (event) => {
    emailInputTouched();
    nameInputTouched();
    companyInputTouched();

    if (formIsInvalid) {
      return;
    }

    dispatch(
      addCustomer({
        email: email,
        name: name,
        company: company,
      })
    );
    closeHandler();
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.close}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Add new customer</DialogTitle>
      <DialogContent>
        <TextField
          error={emailInputHasError}
          helperText={emailInputHasError ? "Entered email is incorrect" : null}
          margin="dense"
          id="customerEmail"
          label="Email address"
          type="email"
          fullWidth
          onBlur={emialInputBlurHandler}
          onChange={emailInputChangeHandler}
        />
        <TextField
          error={nameInputHasError}
          helperText={nameInputHasError ? "Name can not be empty" : null}
          margin="dense"
          id="customerName"
          label="Name"
          type="text"
          fullWidth
          onChange={nameInputChangeHandler}
          onBlur={nameInputBlurHandler}
        />
        <TextField
          error={companyInputHasError}
          helperText={
            companyInputHasError ? "Company name can not be empty" : null
          }
          margin="dense"
          id="customerCompany"
          label="Company name"
          type="text"
          fullWidth
          onChange={companyInputChangeHandler}
          onBlur={companyInputBlurHandler}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={closeHandler} color="primary">
          Cancel
        </Button>
        <Button
          onClick={saveButtonClickHandler}
          color="primary"
          disabled={false}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default EditCustomerDialog;
